import React, { FC, useCallback } from 'react';
import { MentionsInput, Mention } from 'react-mentions';
import './mention-textarea.scss';

export interface MentionedUser {
  userId: string;
  displayName: string;
  currentPermission?: 'NONE' | 'READ' | 'WRITE' | 'ADMIN' | 'OWNER';
}

interface MentionTextareaProps {
  value: string;
  onChange: (value: string, mentions: MentionedUser[]) => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  placeholder?: string;
  disabled?: boolean;
  threadId?: string | null;
}

/**
 * Message composer. Threads are private to their owner, so there is nobody to
 * @-mention; the `@` trigger has no suggestion source and `mentions` is
 * always empty.
 */
const MentionTextarea: FC<MentionTextareaProps> = ({
  value,
  onChange,
  onKeyDown,
  placeholder,
  disabled = false,
}) => {
  const handleChange = useCallback(
    (event: { target: { value: string } }, newValue: string) => {
      onChange(newValue, []);
    },
    [onChange],
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      if (onKeyDown) {
        onKeyDown(e);
      }
    },
    [onKeyDown],
  );

  return (
    <MentionsInput
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      disabled={disabled}
      className='mention-textarea'
      allowSpaceInQuery
    >
      <Mention
        trigger='@'
        data={[]}
        className='mention'
        displayTransform={(id, display) => `@${display}`}
        markup='@[__display__](__id__)'
        appendSpaceOnAdd
      />
    </MentionsInput>
  );
};

export default MentionTextarea;
